import { Menu, Search } from "lucide-react";
import { Link } from "react-router";

import { ClockChip } from "@/features/attendance/components/ClockChip";
import { NotificationBell } from "@/features/notifications/components/NotificationBell";
import { RunningTimer } from "@/features/time/components/RunningTimer";
import { useT } from "@/shared/i18n/useT";
import { Button } from "@/shared/ui/Button";
import { Logo } from "@/shared/ui/Logo";

interface MobileTopbarProps {
  onOpenPalette: () => void;
  onOpenMenu: () => void;
}

/** Only on screens without the sidebar: menu, logo, search, notifications. */
export function MobileTopbar({ onOpenPalette, onOpenMenu }: MobileTopbarProps) {
  const t = useT();
  return (
    <header className="sticky top-0 z-30 border-b border-line bg-surface/85 pt-[env(safe-area-inset-top)] backdrop-blur-lg backdrop-saturate-150 lg:hidden">
      <div className="flex h-14 items-center gap-1 px-2.5">
        <Button
          variant="ghost"
          size="icon"
          className="size-10"
          onClick={onOpenMenu}
          aria-label={t("shell.openMenu")}
        >
          <Menu aria-hidden="true" />
        </Button>
        <Link to="/" aria-label={t("home.nav")} className="rounded-lg px-1 py-1">
          <Logo />
        </Link>
        <div className="ms-auto flex items-center gap-0.5">
          <RunningTimer compact className="me-1" />
          <ClockChip compact className="me-1" />
          <Button
            variant="ghost"
            size="icon"
            className="size-10"
            onClick={onOpenPalette}
            aria-label={t("palette.open")}
          >
            <Search aria-hidden="true" />
          </Button>
          <NotificationBell presentation="sheet" className="size-10" />
        </div>
      </div>
    </header>
  );
}
